
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useState } from "react";
import authService from "../services/auth.service";

const ForgotPass = () => {


  const [studentData, setStudentData] = useState({
    emailId: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const [loading, setLoading] = useState(false);

  const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

 const handleSubmit = async () => {

  if (studentData.emailId === "") {
    Swal.fire({
      title: "Please Enter Your email",
      icon: "error",
      showConfirmButton: true,
    });
    return;
  }

  if (!isValidEmail.test(studentData.emailId)) {
    Swal.fire({
      title: "Please enter a valid email address",
      icon: "warning",
      showConfirmButton: true,
    });
    return;
  }

  setLoading(true);
  try {
    const response = await authService.forgotPassword(studentData.emailId);


    setLoading(false);

    if (response) {
      Swal.fire({
        title: `${response.message}`,
        icon: "success",
        timer: 1000,
        showConfirmButton: false,
      });
     
    } else {
      Swal.fire({
        title: `${response.message}`,
        text: "Please enter valid email",
        icon: "warning",
        timer: 1000,
        showConfirmButton: false,
      });
    }
    // authService.getUser(dispatch);
  } catch (error) {
    setLoading(false);
    Swal.fire({
      title: "Server Busy",
      icon: "error",
      showConfirmButton: true,
    });
  }
};



  return (
    <>
      <div className="contain">
        <div className="login-box">
          <div autoComplete="off" className="student-login-portal">
            <p className="error" />
            <div className="form-group-login-page">
              <label htmlFor="email">Email address</label>
              <input
                onChange={handleInputChange}
                value={studentData.emailId}
                name="emailId"
                type='email' 
                required
                id="emailId"
                placeholder="youremail.@domain.com"
              />
            </div>
            <p className="password-send-mess">Password आपके ईमेल आईडी पर भेजा जाएगा।</p>
        
            <div className="form-actions">
              <button
                onClick={() => handleSubmit()}
                type="submit"
                className="login-btn"
              >
                {loading ? <div class="loader"></div> : "Send"}
              </button>
              <div className="register-link">
                <p>Already have an account?</p>
                <Link to="/student/login">Login</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPass;


